module.exports = __webpack_public_path__ + "static/c-a86e554e3db01342f7ccab3085ea5c57.jpg";